import React from 'react';
import { m } from 'framer-motion';
import { BookOpenIcon, EyeIcon, DumbbellIcon, ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const steps = [{
  n: '1',
  title: 'Abre',
  icon: BookOpenIcon,
  text: 'Elige la sesión o aquello que quieres trabajar.'
}, {
  n: '2',
  title: 'Mira',
  icon: EyeIcon,
  text: 'Consulta los ejercicios y sus diagramas.'
}, {
  n: '3',
  title: 'Entrena',
  icon: DumbbellIcon,
  text: 'Llévalo directamente a pista.'
}];
export function Method() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-172" data-mp="1rqerawpk5pgr">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-173" data-mp="1rr6f3lcwyiwh">
        <SectionTag icon="🎯" data-id="element-174" data-mp="1npbeyk6pybka">El método "Sesión en Mano"</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-175" data-mp="1nr5v7l71pfi1">
          El Método "Sesión en Mano"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-176" data-mp="3i45h1w20r5xr">
          Preparar tu próximo entrenamiento puede ser así de sencillo:
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-4xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-177" data-mp="3ci065h7di7bx">
        {steps.map((step, i) => <React.Fragment key={step.n} data-id="element-178" data-mp="2yk1vomw6av1p" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-white/10 bg-bg-primary p-6 text-center" data-id="element-179" data-mp="32j0x3xip49oe">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-orange/10" data-id="element-180" data-mp="3heqjvxvpgqu6">
                <step.icon size={22} className="text-orange" data-id="element-181" data-mp="3lgbvlfwi6z2s" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-182" data-mp="d1blu214sd3v">
                {step.n}. {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-183" data-mp="rplfhsdsc77l">{step.text}</p>
            </m.div>
            {i < steps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-orange/40 sm:block" aria-hidden="true" data-id="element-184" data-mp="noi2rer1aral" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-sm leading-relaxed text-muted sm:px-6 sm:text-base" data-id="element-185" data-mp="8rhifwb69ym5">
        Sin pasarte horas buscando en YouTube. Sin juntar ejercicios aleatorios. Sin llegar al pabellón
        preguntándote qué vas a hacer.
      </p>
    </section>;
}